import type { UiLocale } from "./types";

const messages = {
  zh: {
    home: "首页", explore: "探索", poets: "诗人", search: "搜索", collections: "专题",
    favorites: "收藏", history: "历史", settings: "设置", about: "关于",
    heroTitle: "诗意人生", heroSubtitle: "在诗词中遇见更美的世界",
    searchPlaceholder: "搜索诗名、作者或诗句…", today: "今日推荐", more: "更多",
    categories: "探索分类", popularPoets: "热门诗人", join: "加入 xHalo Poetry，收藏你喜爱的诗句，与世界分享诗意。",
    signIn: "登录", signUp: "注册", corpusZh: "中文", corpusEn: "English",
    dynasty: "朝代", form: "体裁", theme: "主题", poet: "诗人", period: "时期",
    original: "中文原文", translation: "English Translation", bilingual: "双语对照",
    related: "相关推荐", read: "阅读", play: "朗读", pause: "暂停", retry: "重试",
    loading: "正在翻开诗页…", empty: "暂时没有找到诗作", unavailable: "这首诗暂时没有可用译文。",
    all: "全部", clear: "清除", account: "账户", openChat: "打开 Chat", appearance: "外观",
    fontSize: "字号", lineHeight: "行距", contentWidth: "版心宽度", alignment: "对齐",
    system: "跟随系统", light: "明亮", sepia: "纸张", dark: "夜间", automatic: "自动",
    left: "左对齐", center: "居中", saved: "已收藏", save: "收藏", share: "分享",
    copyLink: "复制链接", copied: "链接已复制", continueReading: "继续阅读", noHistory: "还没有阅读记录。",
    noFavorites: "还没有收藏诗作。", browsePoetry: "去发现诗歌", readerSettings: "阅读设置",
    sourceNote: "文本来源与权利说明", back: "返回", menu: "菜单", close: "关闭",
    works: "首诗作", viewPoet: "查看诗人", discover: "发现诗歌", featuredCollections: "精选专题",
    longPoems: "长诗", nature: "自然山水", moon: "月夜与思乡", love: "爱与时间",
  },
  en: {
    home: "Home", explore: "Explore", poets: "Poets", search: "Search", collections: "Collections",
    favorites: "Favorites", history: "History", settings: "Settings", about: "About",
    heroTitle: "A life in poetry", heroSubtitle: "Find a more beautiful world between the lines",
    searchPlaceholder: "Search poems, poets, or a line…", today: "Today’s pick", more: "More",
    categories: "Explore by", popularPoets: "Popular poets", join: "Join xHalo Poetry to save the poems you love and share their beauty.",
    signIn: "Sign in", signUp: "Register", corpusZh: "中文", corpusEn: "English",
    dynasty: "Dynasty", form: "Form", theme: "Theme", poet: "Poet", period: "Period",
    original: "Original", translation: "中文译文", bilingual: "Bilingual",
    related: "Related reading", read: "Read", play: "Listen", pause: "Pause", retry: "Try again",
    loading: "Opening the poem…", empty: "No poems found", unavailable: "No licensed translation is available for this poem yet.",
    all: "All", clear: "Clear", account: "Account", openChat: "Open Chat", appearance: "Appearance",
    fontSize: "Font size", lineHeight: "Line height", contentWidth: "Reading width", alignment: "Alignment",
    system: "System", light: "Light", sepia: "Paper", dark: "Dark", automatic: "Automatic",
    left: "Left", center: "Center", saved: "Saved", save: "Save", share: "Share",
    copyLink: "Copy link", copied: "Link copied", continueReading: "Continue reading", noHistory: "No reading history yet.",
    noFavorites: "No saved poems yet.", browsePoetry: "Discover poetry", readerSettings: "Reading settings",
    sourceNote: "Text source and rights", back: "Back", menu: "Menu", close: "Close",
    works: "works", viewPoet: "View poet", discover: "Discover poetry", featuredCollections: "Featured collections",
    longPoems: "Long poems", nature: "Nature", moon: "Moonlight & home", love: "Love & time",
  },
} as const;

export type MessageKey = keyof typeof messages.zh;
export function t(locale: UiLocale, key: MessageKey) { return messages[locale][key] ?? messages.en[key]; }

export function localeFromPath(pathname: string): UiLocale {
  return pathname.split("/")[1] === "en" ? "en" : "zh";
}
